import { GEOLOCATION_ERROR } from '@/shared/vaccination/enums';

export type GeolocationClientError = Exclude<
  GEOLOCATION_ERROR,
  GEOLOCATION_ERROR.LOW_ACCURACY
>;

export interface CoordinatesResult {
  position?: GeolocationPosition;
  error?: GeolocationClientError;
}

/**
 * Определяет текущее местоположение. Никогда не отклоняет промис: при сбое возвращает код причины,
 * чтобы сохранение результатов вакцинации не блокировалось.
 */
export const getCurrentCoordinates = (
  options: PositionOptions = {},
): Promise<CoordinatesResult> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ error: GEOLOCATION_ERROR.UNSUPPORTED });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => resolve({ position }),
      (error) => {
        const codes: Record<number, GeolocationClientError> = {
          [error.PERMISSION_DENIED]: GEOLOCATION_ERROR.PERMISSION_DENIED,
          [error.POSITION_UNAVAILABLE]: GEOLOCATION_ERROR.POSITION_UNAVAILABLE,
          [error.TIMEOUT]: GEOLOCATION_ERROR.TIMEOUT,
        };

        resolve({ error: codes[error.code] ?? GEOLOCATION_ERROR.POSITION_UNAVAILABLE });
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
        ...options,
      },
    );
  });
};
